import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export const FormikConfig: any =  (handleSubmit: any) => {
  const { t } = useTranslation();

  return useFormik({
    initialValues: {
      title: '',
      description: '',
      cover_image: null,
    },

    validationSchema: Yup.object({
      title: Yup.string()
        .required(t('field_required'))
        .max(80, t('max_invalid', { number: 80 })),

      description: Yup.string()
        .notRequired()
        .min(3, t('min_invalid', { number: 3 }))
        .max(255, t('max_invalid', { number: 255 })),

      cover_image: Yup.mixed().notRequired(),
    }),

    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
};
